import React, { useRef, useState } from "react";
import { BsBellFill } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineClockCircle } from "react-icons/ai";
import { BsBookmarkPlus } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import {
  BiLogoFacebook,
  BiLogoInstagramAlt,
  BiLogoYoutube,
  BiLogoTwitter,
  BiLogoLinkedin,
} from "react-icons/bi";

import { logo, flower, mainLeaf } from "../../assets";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Footer = () => {
  const navigate = useNavigate();
  const form = useRef();
  const [subEmail, setSubEmail] = useState("");

  const reset = () => {
    setSubEmail("");
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_t15vteq",
        "template_3lyo8sq",
        form.current,
        "wLuR42rWS-d2I4PgN"
      )
      .then(
        toast.success("Successfully Suscribed!", {
          position: "top-center",
          autoClose: 1000,
        })
      )
      .catch((err) =>
        toast.error("Something went wrong", {
          position: "top-center",
          autoClose: 1000,
        })
      );

    reset();
  };

  return (
    <div id="footer">
      <img src={flower} alt="" className="mainLeaf" />
      <img src={mainLeaf} alt="" className="mainLeaf2" />

      <div className="animated-texts">
        <ul>
          <li>Laser Treat Bangladesh</li>
          <li>ISO Certified Clinic in Bangladesh</li>
          <li>Best Asthetic Treatments in Bangladesh</li>
          <li>Best Anti-Aging Treatments in Bangladesh</li>
          <li>Best Body Shapping Treatments in Bangladesh</li>
          <li>Best Dermatology Treatments in Bangladesh</li>
          <li>Best Sexology Treatments in Bangladesh</li>
          <li>Best Hair Transplant in Bangladesh</li>
        </ul>
      </div>

      <div className="content">
        <div className="top">
          <div className="left">
            <img src={logo} alt="" className="footerLogo" />
            <p>Hotline: 09678006007</p>
            <h2>Never miss the next update form us.</h2>

            <form ref={form} onSubmit={sendEmail}>
              <input
                type="email"
                name="from_email"
                value={subEmail}
                onChange={(e) => setSubEmail(e.target.value)}
                id=""
                placeholder="Enter email"
              />
              <button type="submit">
                <BsBellFill className="bell" /> Subscribe
              </button>
            </form>
          </div>
          <div className="middle1">
            <p className="heading">Treatments</p>
            <div className="links">
              <Link className="link" to="/asthetic-treatments">
                Asthetic
              </Link>
              <Link className="link" to="/anti-aging-treatments">
                Anti-Aging
              </Link>
              <Link className="link" to="/body-shaping-treatments">
                Body Shapping
              </Link>
              <Link className="link" to="/dermatology-treatments">
                Dermatology
              </Link>
              <Link className="link" to="/sexology-treatments">
                Sexology
              </Link>
            </div>
          </div>
          <div className="middle2">
            <p className="heading">Locations</p>
            <ul>
              <li>
                <CiLocationOn className="loc" /> The Laureate, House: 56 (3rd
                Floor), Road: 11, Block: F, Banani, Dhaka-1213, Bangladesh.
              </li>
              <li>
                <CiLocationOn className="loc" />
                Garibe Newaz Avenue, Plot No: 30 (4th Floor), Sector:13, Uttara,
                Dhaka-1230, Bangladesh.
              </li>
            </ul>
          </div>
          <div className="right">
            <p className="heading">Contact</p>
            <div className="time">
              <p>
                <AiOutlineClockCircle className="clock" /> 09.00 am - 09.00 pm
              </p>
              <small>Everyday</small>
            </div>
            <button
              className="booking"
              onClick={() => navigate("/appointment")}
            >
              <small>Book Appointment</small>
            </button>
          </div>
        </div>
        <div className="bottom">
          <small>Copyright © 2023 Laser Treat</small>

          <div className="footerSocial">
            <Link to="/">
              <BiLogoFacebook className="socialIO" />
            </Link>
            <Link to="/">
              <BiLogoInstagramAlt className="socialIO" />
            </Link>
            <Link to="/">
              <BiLogoYoutube className="socialIO" />
            </Link>
            <Link to="/">
              <BiLogoTwitter className="socialIO" />
            </Link>
            <Link to="/">
              <BiLogoLinkedin className="socialIO" />
            </Link>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Footer;
